import PrimeVue from 'primevue/config';
import PrimeLocale from 'primelocale/nl.json';
import { type App } from 'vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';
import { PrimeVuePt } from '@shared/plugin/prime-vue';
import ToastService from 'primevue/toastservice';
import { createPinia } from 'pinia';

import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query';
import { env } from '@configuration/env';
import i18next from 'i18next';
import { zodI18nMap } from 'zod-i18n-map';
import translation from 'zod-i18n-map/locales/nl/zod.json';
import { z } from 'zod';
import { logger } from '@tools/logging';
import { type ApplicationInsightsOptions, plugin } from '@application-insights/aiSetup';
import { applicationRootInjectionKey } from '@tools/applicationRoot';
import { maskaDirectiveArguments, sanitizedHtmlDirectiveArguments } from './directives';

export const appDefaults = {
  install(app: App, aiOptions: ApplicationInsightsOptions) {
    const vueQueryPluginOptions: VueQueryPluginOptions = {
      enableDevtoolsV6Plugin: true,
      queryClientConfig: {
        defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
      },
    };

    app
      .use(PrimeVue, {
        unstyled: true,
        pt: PrimeVuePt,
        locale: PrimeLocale.nl,
        ptOptions: {
          mergeSections: true,
          mergeProps: true,
        },
      })
      .use(ToastService)
      .use(createPinia())
      .use(VueQueryPlugin, vueQueryPluginOptions)
      .component('font-awesome-icon', FontAwesomeIcon)
      .provide(applicationRootInjectionKey, 'body')
      .directive(...maskaDirectiveArguments)
      .directive(...sanitizedHtmlDirectiveArguments);

    if (!env.VUE_APP_SKIP_INSIGHTS) {
      app.use(plugin, aiOptions);
    }
  },
};

const invalidTypeMelding = 'Dit veld is verplicht';
translation.errors.invalid_type_received_undefined = invalidTypeMelding;
translation.errors.invalid_type = invalidTypeMelding;

i18next.init({
  lng: 'nl',
  resources: {
    nl: { zod: translation },
  },
});

z.setErrorMap(zodI18nMap);

logger.debug('Using following base url:', env.BASE_URL);
